// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Redesign Section Styling */
.redesign-section {
  background-color: #f8f9fa;
  padding: 2rem;
  border-radius: 4px;
}

/* Form Styling */
.form-control {
  font-size: 0.9rem;
}

.form-check-input {
  cursor: pointer;
  width: 1.1rem;
  height: 1.1rem;
  margin-top: 0rem;
}

.form-check {
  padding-left: 1.5rem;
}

.form-check-label {
  margin-left: 1.5rem;
}

/* Label alignment */
label.col-form-label {
  padding-top: calc(0.375rem + 1px);
}

/* Button styling */
.button.small {
  min-width: 80px;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/redesign/redesign.component.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB","sourcesContent":["/* Redesign Section Styling */\n.redesign-section {\n  background-color: #f8f9fa;\n  padding: 2rem;\n  border-radius: 4px;\n}\n\n/* Form Styling */\n.form-control {\n  font-size: 0.9rem;\n}\n\n.form-check-input {\n  cursor: pointer;\n  width: 1.1rem;\n  height: 1.1rem;\n  margin-top: 0rem;\n}\n\n.form-check {\n  padding-left: 1.5rem;\n}\n\n.form-check-label {\n  margin-left: 1.5rem;\n}\n\n/* Label alignment */\nlabel.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n}\n\n/* Button styling */\n.button.small {\n  min-width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
